/* CozyCrafts redesign: reveal-on-scroll + "Try your photo on an air freshener" */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal: only elements below the first screen are hidden, so nothing visible ever blinks out. */
  function setupReveal() {
    var groups = document.querySelectorAll('[data-cc-group]');
    if (!('IntersectionObserver' in window) || !groups.length) return;
    doc.classList.add('cc-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    groups.forEach(function (g) {
      g.querySelectorAll('[data-cc-r]').forEach(function (el, i) { el.style.setProperty('--i', i); });
      var r = g.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { g.classList.add('is-in'); }
      else { io.observe(g); }
    });
  }

  /* Live thing: choose a photo from your phone and a scent, see it as a 7 x 9 cm air freshener. Nothing is uploaded. */
  function setupAir() {
    var root = document.querySelector('[data-cc-air]');
    if (!root) return;
    var card = root.querySelector('.cc-air__card');
    var input = root.querySelector('.cc-air__file');
    var pick = root.querySelector('[data-cc-pick]');
    var cap = root.querySelector('.cc-air__cap');
    var order = root.querySelector('[data-cc-order]');
    var scentLabel = root.querySelector('[data-cc-scent]');
    var scent = 'Lychee Peony';
    var hasPhoto = false;
    function say() {
      if (!cap) return;
      var spray = scent === 'Unscented' ? 'with an unscented spray' : 'with a ' + scent + ' spray';
      cap.textContent = (hasPhoto ? 'Your photo at 7 by 9 cm, ' : 'Shown at 7 by 9 cm ') + spray + '.';
    }
    if (pick && input) pick.addEventListener('click', function () { input.click(); });
    if (input) input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      if (!f) return;
      var img = card.querySelector('img');
      if (!img) { img = document.createElement('img'); card.insertBefore(img, card.firstChild); }
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = URL.createObjectURL(f); img.alt = 'Your photo on the air freshener';
      if (!reduce) { card.classList.remove('is-new'); void card.offsetWidth; card.classList.add('is-new'); }
      hasPhoto = true; say();
      input.value = '';
    });
    root.querySelectorAll('input[data-name]').forEach(function (r) {
      r.addEventListener('change', function () {
        scent = r.getAttribute('data-name');
        if (scentLabel) scentLabel.textContent = scent;
        if (order) {
          var verb = order.getAttribute('data-verb') || 'Order with';
          if (order.tagName === 'A') order.href = '/products/personalized-air-freshener?variant=' + r.value;
          order.textContent = scent === 'Unscented' ? verb.replace(/ with$/, '') + ' unscented' : verb + ' ' + scent;
        }
        say();
      });
    });
  }

  /* Live thing: fill the 12-photo frame with photos from your phone and pick a colour. Nothing is uploaded. */
  function setupFrame() {
    var root = document.querySelector('[data-cc-frame]');
    if (!root) return;
    var frame = root.querySelector('.cc-fr');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.cc-fr__tile'));
    var input = root.querySelector('.cc-try__file');
    var pick = root.querySelector('[data-cc-pick]');
    var cap = root.querySelector('.cc-try__cap');
    var order = root.querySelector('[data-cc-order]');
    var target = 4;
    function mark() { tiles.forEach(function (t, i) { t.classList.toggle('is-target', i === target); t.setAttribute('aria-pressed', i === target ? 'true' : 'false'); }); }
    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () { target = i; mark(); if (cap) cap.textContent = 'Square ' + (i + 1) + ' of 12 selected. Choose photos to fill from here.'; });
    });
    if (pick && input) pick.addEventListener('click', function () { input.click(); });
    if (input) input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || [], 0, 12);
      if (!files.length) return;
      files.forEach(function (f, n) {
        var t = tiles[(target + n) % tiles.length];
        var img = t.querySelector('img');
        if (!img) { img = document.createElement('img'); t.appendChild(img); }
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = URL.createObjectURL(f); img.alt = 'Your photo as a magnet';
        if (!reduce) { t.classList.remove('is-new'); void t.offsetWidth; t.classList.add('is-new'); }
      });
      target = (target + files.length) % tiles.length; mark();
      if (cap) cap.textContent = (files.length === 1 ? 'Your photo is' : files.length + ' of your photos are') + ' in the frame at 53 mm. Tap a square to choose where the next one goes.';
      input.value = '';
    });
    root.querySelectorAll('input[data-colour]').forEach(function (r) {
      r.addEventListener('change', function () {
        frame.setAttribute('data-c', r.getAttribute('data-colour'));
        if (order) order.textContent = 'Add to cart in ' + r.getAttribute('data-label');
      });
    });
    mark();
  }

  /* Live thing: pick a bundle and photos, see them as 53 mm magnets on a fridge door.
     Prices and the add to cart go through the quantity-bundle widget in the buy box, so its discounts apply. */
  function setupFridge() {
    var root = document.querySelector('[data-cc-fridge]');
    if (!root) return;
    var mags = root.querySelector('.cc-fz__mags');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.cc-fz__mag'));
    var input = root.querySelector('.cc-fz__file');
    var pick = root.querySelector('[data-cc-pick]');
    var cap = root.querySelector('.cc-fz__cap');
    var order = root.querySelector('[data-cc-order]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="cc-pack"]'));
    var n = 12, target = 0, idx = 2;
    function boxes() { return Array.prototype.slice.call(document.querySelectorAll('.section-product-info .n9_qbreaks_box')); }
    function choose(i) { var b = boxes()[i]; if (!b) return; var hit = b.querySelector('.n9_qbreaks_main_div_layout5') || b; hit.click(); }
    function priceOf(i) {
      var b = boxes()[i]; if (!b) return null;
      var m = b.innerText.match(/\$\s?[\d,]+(\.\d\d)?/g); return m ? m[m.length - 2] || m[0] : null;
    }
    function syncPrices() {
      radios.forEach(function (r, i) { var p = priceOf(i); var s = r.parentNode.querySelector('[data-cc-price]'); if (p && s) s.textContent = p; });
    }
    function label() {
      var p = priceOf(idx);
      if (order) order.textContent = 'Add ' + n + (n === 1 ? ' magnet' : ' magnets') + ' to cart' + (p ? ', ' + p : '');
    }
    function mark() { tiles.forEach(function (t, i) { var on = i === target && i < n; t.classList.toggle('is-target', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    function setN(v, i) {
      n = v; idx = i; mags.setAttribute('data-n', String(v));
      if (target >= n) target = 0;
      mark(); label();
      if (cap) cap.textContent = n + (n === 1 ? ' magnet, ' : ' magnets, each ') + '53 by 53 mm, on a 45 cm wide stretch of fridge door.';
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { setN(parseInt(r.value, 10), parseInt(r.getAttribute('data-i'), 10)); choose(idx); });
    });
    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () { target = i; mark(); if (cap) cap.textContent = 'Magnet ' + (i + 1) + ' selected. Choose photos to fill from here.'; });
    });
    if (pick && input) pick.addEventListener('click', function () { input.click(); });
    if (input) input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || [], 0, n);
      if (!files.length) return;
      files.forEach(function (f, k) {
        var t = tiles[(target + k) % n]; var img = t.querySelector('img');
        img.removeAttribute('srcset'); img.src = URL.createObjectURL(f); img.alt = 'Your photo as a magnet';
        t.classList.add('is-user');
        if (!reduce) { t.classList.remove('is-new'); void t.offsetWidth; t.classList.add('is-new'); }
      });
      target = (target + files.length) % n; mark();
      if (cap) cap.textContent = (files.length === 1 ? 'Your photo is' : files.length + ' of your photos are') + ' on the fridge at 53 mm. Tap a magnet to choose where the next one goes.';
      input.value = '';
    });
    if (order) order.addEventListener('click', function (e) {
      var b = boxes()[idx]; var atc = document.querySelector('.section-product-info .add_to_cart_button');
      if (!b || !atc) return; /* no widget: the link scrolls to the buy box */
      e.preventDefault(); choose(idx);
      setTimeout(function () { atc.click(); }, 250);
    });
    /* tidy the bundle widget's labels: no emoji, readable badge and prices in the site's colours */
    function tidy() {
      boxes().forEach(function (bx) {
        Array.prototype.slice.call(bx.querySelectorAll('.n9_qbreaks_rightPopular_div_layout5')).forEach(function (p) {
          p.textContent = p.textContent.replace(/[^\w\s$.,+%-]/g, '').trim();
          p.style.setProperty('background-color', '#1C1C1B', 'important'); p.style.setProperty('border-color', '#1C1C1B', 'important'); p.style.setProperty('color', '#FFFFFF', 'important'); p.style.setProperty('border-radius', '0', 'important');
        });
        Array.prototype.slice.call(bx.querySelectorAll('.n9_qbreaks_rightPrice1_div_layout5, .n9_qbreaks_rightPrice1_div_layout5 *')).forEach(function (p) { p.style.setProperty('color', '#1C1C1B', 'important'); });
      });
    }
    /* the widget renders after load; read its prices once it is there */
    var tries = 0, timer = setInterval(function () { tries++; if (boxes().length || tries > 40) { clearInterval(timer); tidy(); syncPrices(); label(); var b = boxes()[idx]; if (b && b.className.indexOf('n9Selected') < 0) choose(idx); } }, 250);
    mark(); label();
  }

  /* Live thing: choose packs of paper and read the real price per sheet, total and saving. */
  function setupCalc() {
    var root = document.querySelector('[data-cc-calc]');
    if (!root) return;
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[data-packs]'));
    var q = function (s) { return root.querySelector(s); };
    var money = function (c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
    function show(r) {
      var packs = parseInt(r.getAttribute('data-packs'), 10), price = parseInt(r.getAttribute('data-price'), 10), single = parseInt(r.getAttribute('data-single'), 10) || 0;
      var per = parseInt(root.getAttribute('data-sheets'), 10) || 100, sheets = packs * per, save = single * packs - price;
      var cps = price / sheets; q('[data-cc-per]').textContent = cps >= 99.5 ? money(Math.round(cps)) : (Math.round(cps * 10) / 10).toFixed(1) + '¢';
      q('[data-cc-sheets]').textContent = sheets.toLocaleString('en-AU');
      q('[data-cc-total]').textContent = money(price);
      q('[data-cc-save]').textContent = save > 0 ? money(save) : 'None on one ' + (root.getAttribute('data-unit') || 'pack');
      var unit = root.getAttribute('data-unit') || 'pack', ship = r.getAttribute('data-ship');
      if (ship !== null) {
        var sd = q('[data-cc-delivery]'); if (sd) sd.textContent = money(parseInt(ship, 10));
        q('[data-cc-ship]').textContent = 'Standard delivery, 1 to 5 business days. Free local delivery within 30 km of us.';
      } else {
        q('[data-cc-ship]').textContent = price > 4999 ? 'Ships free Australia-wide.' : '$15 express shipping Australia-wide, or free local delivery within 30 km of us on orders over $14.99.';
      }
      q('[data-cc-order]').textContent = 'Add ' + packs + ' ' + unit + (packs === 1 ? '' : 's') + ' to cart, ' + money(price);
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { show(r); }); if (r.checked) show(r); });
  }

  /* Gift note. When the add to cart button sits in the product form, the note goes on the line item.
     When an app replaces that button (the quantity bundles), the note is saved on the cart instead,
     so it still reaches the order; the box is moved to sit just above the app's button. */
  function setupNote() {
    var notes = Array.prototype.slice.call(document.querySelectorAll('textarea[data-cc-note]'));
    if (!notes.length) return;
    var atc = document.querySelector('.section-product-info .add_to_cart_button');
    var pf = atc && atc.form;
    var onCart = !pf || !!document.querySelector('.section-product-info [id*="addly_bundle_upsell"]');
    var t;
    function save(v) {
      clearTimeout(t);
      t = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift note': v } }) }).catch(function () {});
      }, 500);
    }
    notes.forEach(function (n) {
      var pid = pf && pf.getAttribute('id');
      if (!n.form && pid) n.setAttribute('form', pid);
      if (onCart) n.removeAttribute('name');
      n.addEventListener('input', function () {
        notes.forEach(function (o) { if (o !== n) o.value = n.value; });
        if (onCart) save(n.value.trim());
      });
    });
    if (onCart) {
      var box = notes[0].closest('.cc-note'), tries = 0;
      var timer = setInterval(function () {
        tries++;
        var end = document.querySelector('.section-product-info .n9_qbreaks_endBtn_div_layout5');
        if (end && box) { end.parentNode.insertBefore(box, end); box.classList.add('cc-note--in'); clearInterval(timer); }
        else if (tries > 40) clearInterval(timer);
      }, 250);
    }
  }

  function init() { setupAir(); setupFrame(); setupFridge(); setupCalc(); setupNote(); setupReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
